<template>
  <div class="register-container">
    <h3 class="brand-title">HobiBaca</h3>
    <h2>Daftar Akun Baru</h2>
    
    <RegisterForm />
    
    <div class="auth-links">
      <p class="login-link">
        Sudah punya akun? <router-link to="/login">Login di sini</router-link>
      </p>
    </div>
    
    <div class="author-cta">
      <h4>Apakah Anda seorang Penulis?</h4>
      <p>Bagikan karya Anda dan dapatkan penghasilan dari ribuan pembaca</p>
      <router-link to="/register-author" class="author-register-btn">
        <font-awesome-icon :icon="['fas', 'pen-fancy']" /> Daftar sebagai Penulis
      </router-link>
    </div>
  </div>
</template>

<script>
import RegisterForm from '@/components/RegisterForm.vue';
import { useHead } from '@unhead/vue';

export default {
  name: 'RegisterPage',
  components: {
    RegisterForm
  },
  setup() {
    useHead({
      title: 'Daftar Akun Baru | HobiBaca',
      meta: [
        {
          name: 'description',
          content: 'Daftar akun baru di HobiBaca untuk akses ke ribuan buku. Baca bab pertama gratis, daftar akun untuk bab kedua, dan langganan untuk akses penuh.'
        },
        {
          name: 'keywords',
          content: 'daftar HobiBaca, buat akun HobiBaca, registrasi HobiBaca, baca buku online, buku digital'
        },
        {
          property: 'og:title',
          content: 'Daftar Akun Baru | HobiBaca'
        },
        {
          property: 'og:description',
          content: 'Daftar akun gratis di HobiBaca untuk mulai membaca ribuan buku menarik. Akses bab kedua setelah pendaftaran.'
        },
        {
          property: 'og:type',
          content: 'website'
        },
        {
          property: 'og:url',
          content: window.location.href
        },
        {
          name: 'twitter:card',
          content: 'summary'
        },
        {
          name: 'twitter:title',
          content: 'Daftar Akun Baru | HobiBaca'
        },
        {
          name: 'twitter:description',
          content: 'Daftar akun gratis di HobiBaca untuk mulai membaca ribuan buku menarik.'
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: window.location.href
        }
      ]
    });
  }
};
</script>

<style scoped>
.register-container {
  max-width: 400px;
  margin: 50px auto;
  padding: 30px;
  border-radius: 10px;
  background-color: #ffffff;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.brand-title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #488e71;
}

h2 {
  font-size: 18px;
  margin-bottom: 25px;
  color: #666;
}

.auth-links {
  margin-top: 20px;
}

.login-link {
  margin-bottom: 10px;
}

.login-link a {
  color: #488e71;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s;
}

.login-link a:hover {
  color: #f66a24;
  text-decoration: underline;
}

.author-cta {
  margin-top: 30px;
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border-left: 4px solid #488e71;
}

.author-cta h4 {
  margin-top: 0;
  color: #333;
  font-size: 16px;
  margin-bottom: 8px;
}

.author-cta p {
  color: #666;
  margin-bottom: 15px;
  font-size: 14px;
}

.author-register-btn {
  display: inline-block;
  background-color: #488e71;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  font-weight: 600;
  text-decoration: none;
  transition: background-color 0.3s;
}

.author-register-btn:hover {
  background-color: #3a7259;
  text-decoration: none;
  color: white;
}

.author-register-btn svg {
  margin-right: 5px;
}
</style>